import { useQuery } from '@tanstack/react-query'
import { kioskFetch } from './kiosk'

export interface KioskAlert {
  id: string
  severity: string
  title: string
  entity_name: string | null
  opened_at: string
}

/** Pure: ids in `open` not yet in `seen`. */
export function newAlertIds(seen: Set<string>, open: { id: string }[]): string[] {
  return open.filter((a) => !seen.has(a.id)).map((a) => a.id)
}

export function useOpenAlerts() {
  return useQuery<KioskAlert[]>({
    queryKey: ['k-open-alerts'],
    queryFn: () => kioskFetch('/api/alerts?open_only=true'),
    refetchInterval: 10_000,
  })
}

/** Synthesized chime — no asset. critical = 3 descending beeps, else 1 soft. */
export function playAlertChime(severity: string): void {
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
    const ctx = new Ctx()
    const critical = severity === 'critical'
    const freqs = critical ? [880, 660, 440] : [660]
    const gainPeak = critical ? 0.5 : 0.25
    freqs.forEach((f, i) => {
      const t0 = ctx.currentTime + i * 0.22
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = 'sine'
      osc.frequency.value = f
      gain.gain.setValueAtTime(0, t0)
      gain.gain.linearRampToValueAtTime(gainPeak, t0 + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.2)
      osc.connect(gain).connect(ctx.destination)
      osc.start(t0)
      osc.stop(t0 + 0.22)
    })
    // let the graph finish then release
    setTimeout(() => ctx.close().catch(() => {}), (freqs.length * 0.22 + 0.3) * 1000)
  } catch {
    // Web Audio unavailable (e.g. jsdom in tests) — silent, non-fatal.
  }
}
